export enum TypologiesEnum {
    DRIVER = 'DRIVER',
    MERCHANT = 'MERCHANT',
    SUBUSER = 'SUBUSER',
    USER = 'USER',
    CARRIER = 'CARRIER',
    SERVICE_STATION = 'SERVICE_STATION',
    MINDY_CLARO_KNOWLEDGE_USER = 'MINDY_CLARO_KNOWLEDGE_USER',
    FLEETCARE_USER = 'FLEETCARE_USER',
    /** Usuario invitado desde OMS. Sólo la llevan los que se dan de alta por esa invitación. */
    OMS_USER = 'OMS_USER',
}
